import React from "react"
import { Flex, Box, Image, Text, Link } from "rebass"
import MCDLogo from "../images/mcd-logo-white.svg"

const Footer = ({ links }) => (
  <Box bg="text" p={[4, 4, 4]}>
    <Flex flexDirection={["column", "row"]}>
      <Box flex={1}>
        <Link variant="footer" href="https://mcdbooks.com">
          <Flex alignItems="center" justifyContent={["center", "start"]}>
            <Image width={48} src={MCDLogo} />
            <Text ml={3}>
              <span>MCD × FSG</span>
            </Text>
          </Flex>
        </Link>
      </Box>
      <Flex flexDirection={["column", "row"]} alignItems="center" mt={[3, 0]}>
        {links.map(link => (
          <Link
            variant="footer"
            mt={[4, 0]}
            ml={[0, 3, 5]}
            key={link.label}
            href={link.url}
          >
            <span>{link.label}</span>
          </Link>
        ))}
      </Flex>
    </Flex>
  </Box>
)

export default Footer
